import React, {useContext, useEffect, useState} from 'react';
import {AgentContext} from "../context/agent-context.jsx";
import DefaultHeader from "../utils/default-header.jsx";
import {Modal} from "../../../../../components/modal/modal.jsx";
import Button from "../../../../../components/button/button.jsx";
import InputTextarea from "../../../../../components/input/input-textarea.jsx";
import userService from "../../../../../services/web/user-service.js";
import projectUtils from "../../../../../utils/project-utils.js";
import {toast} from "react-toastify";

const LoginBlock = ({open, setOpen}) => {
    const {id, user, setIsLoading, setUser, setReadyToBlock} = useContext(AgentContext)
    const [observation, setObservation] = useState("")

    const block = () => {
        setIsLoading(true);

        userService.blockLogin(id, DefaultHeader)
            .then(() => {
                setUser(prev => ({
                    ...prev,
                    user: {
                        ...user.user,
                        observation: user.user.observation ? user.user.observation + "\n" + observation : observation
                    }
                }));
                setObservation("")
                setReadyToBlock(true);
                setOpen(false)

                toast.success("Login bloqueado com sucesso")
            })
            .catch(() => projectUtils.swalErrorMessage("", "Não foi possível prosseguir.", "Ok"))
            .finally(() => setIsLoading(false))
    }

    return (
        <>
            <Modal isCloseClick={false} open={open} setOpen={() => setOpen(false)} centered size="xl" backdrop="static" keyboard={false}
                   title={"Justificativa para bloquear login"} className={"w-4/12"}>

                <Modal.Body className="p-2">
                    <div className="row">
                        <div className="col-12">
                            <InputTextarea style={{height: '100px'}} label="Observações" value={observation}
                                           onChange={({target: {value}}) => setObservation(value)}
                            />
                        </div>
                    </div>
                </Modal.Body>

                <Modal.Footer className={"p-2"}>
                    <div className="w-full flex justify-end m-0">
                        <Button
                            target="danger"
                            onClick={block}
                            actionFeedbackType="save"
                            loadingText="Bloqueando..."
                            successText="Login bloqueado com sucesso"
                        >
                            Bloquear
                        </Button>
                    </div>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default LoginBlock;